<template>
    <div class="n2-form-group">
        <template v-if="type==='text'">
            <label class="n2-form-label">{{ label }}</label>
            <input type="text" v-bind:autocomplete="autocomplete" v-bind:placeholder="placeholder" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="n2-input-default" v-bind:class="{'n2-invalid-field': errors, 'n2-text-right': text_right }" />
            <slot></slot>
        </template>
        <template v-if="type==='password'">
            <label class="n2-form-label">{{ label }}</label>
            <input type="password" v-bind:autocomplete="autocomplete" v-bind:placeholder="placeholder" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="n2-input-default" v-bind:class="{'n2-invalid-field': errors, 'n2-text-right': text_right }" />
            <slot></slot>
        </template>
        <template v-if="type==='number'">
            <label class="n2-form-label">{{ label }}</label>
            <input type="number" v-bind:autocomplete="autocomplete" v-bind:placeholder="placeholder" v-bind:step="step" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="n2-input-default" v-bind:class="{'n2-invalid-field': errors, 'n2-text-right': text_right  }" />
            <slot></slot>
        </template>
        <template v-if="type==='date'">
            <label class="n2-form-label">{{ label }}</label>
            <input type="date" v-bind:autocomplete="autocomplete" v-bind:placeholder="placeholder" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="n2-input-default" v-bind:class="{'n2-invalid-field': errors, 'n2-text-right': text_right  }" />
            <slot></slot>
        </template>
        <template v-if="type==='checkbox'">
            <label class="n2-checkbox-lable">
                <input type="checkbox" v-bind:checked="value" v-on:change="$emit('input', $event.target.checked)" class="n2-checkbox-input" v-bind:class="{'n2-invalid-field': errors }" />
                <span class="n2-checkbox-text">{{ label }}</span>
                <slot name="inline"></slot>
            </label>
            <slot></slot>
        </template>
        <template v-if="type==='select'">
            <label class="n2-form-label">{{ label }}</label>
            <select v-bind:placeholder="placeholder" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="n2-input-default" v-bind:class="{'n2-invalid-field': errors }">
                <slot name="options"></slot>
            </select>
            <slot></slot>
        </template>
        <template v-if="type==='textarea'">
            <label class="n2-form-label">{{ label }}</label>
            <textarea v-bind:autocomplete="autocomplete" v-bind:placeholder="placeholder" v-bind:cols="cols" v-bind:rows="rows" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" class="n2-input-default" v-bind:class="{'n2-invalid-field': errors }">
            </textarea>
            <slot></slot>
        </template>
        <ul class="n2-valid" v-bind:class="{'n2-errors':errors}">
            <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
    </div>
</template>
<script>
    export default {
        name: 'BaseInput',
        props: ['value', 'label', 'type', 'autocomplete', 'placeholder', 'errors', 'invalid', 'text_right', 'step', 'cols', 'rows']
    }
</script>
